// frontend/src/utils/vehicleStatuses.js

export const VEHICLE_STATUS_OPTIONS = [
  { value: 'anunciado-mar-aberto', label: 'Anunciado - Mar Aberto' },
  { value: 'anunciado-mar-fechado', label: 'Anunciado - Mar Fechado' },
  { value: 'disponivel-para-venda', label: 'Disponível para Venda' },
  { value: 'fila-publicacao', label: 'Fila de publicação' },
  { value: 'concluido', label: 'Concluído' },
  { value: 'suspenso', label: 'Suspenso' },
  { value: 'vendido-nao-pago', label: 'Vendido (não pago)' },
  { value: 'vendido-pendente-repasse', label: 'Vendido - Pendente repasse financeiro' }
];

export const VEHICLE_STATUS_LABELS = {
  'anunciado-mar-aberto': 'Anunciado - Mar Aberto',
  'anunciado-mar-fechado': 'Anunciado - Mar Fechado',
  'disponivel-para-venda': 'Disponível para Venda',
  'fila-publicacao': 'Fila de publicação',
  'concluido': 'Concluído',
  'suspenso': 'Suspenso',
  'vendido-nao-pago': 'Vendido (não pago)',
  'vendido-pendente-repasse': 'Vendido - Pendente repasse financeiro'
};

export const VEHICLE_STATUS_CLASSES = {
  'anunciado-mar-aberto': 'bg-blue-100 text-blue-800',
  'anunciado-mar-fechado': 'bg-indigo-100 text-indigo-800',
  'disponivel-para-venda': 'bg-green-100 text-green-800',
  'fila-publicacao': 'bg-yellow-100 text-yellow-800',
  'concluido': 'bg-gray-100 text-gray-800',
  'suspenso': 'bg-orange-100 text-orange-800',
  'vendido-nao-pago': 'bg-red-100 text-red-800',
  'vendido-pendente-repasse': 'bg-purple-100 text-purple-800'
};

// Status que devem aparecer no catálogo público
export const CATALOG_VISIBLE_STATUSES = [
  'disponivel-para-venda',
  'anunciado-mar-aberto', 
  'anunciado-mar-fechado'
];